import { render, staticRenderFns } from "./RejectionCauseRestoreContainer.vue?vue&type=template&id=4eb971a1"
import script from "./RejectionCauseRestoreContainer.vue?vue&type=script&lang=js"
export * from "./RejectionCauseRestoreContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports